import React, { Component } from 'react'
import { Button, Col, Label, Row } from 'reactstrap'
import { IconeSetaSubir, IconeSetaDescer } from '../../../../comum/components/Icones'
import { observer } from 'mobx-react';
import moment from 'moment';
import { formatNullableValue } from '../../../../../utils/formatar';

@observer
export default class DadosProcesso extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;

        this.itens = [
            {
                label:"Número DI",
                value: "NumeroDi",
                hidden: false
            }, 
            {
                label: "Número BL",
                value: "NumeroBl",
                hidden: false
            }, 
            {
                label:"Nome do navio",
                value: "Navio",
                hidden: false
            }, 
            {
                label:"Data atracação",
                value: "DtRealAtracacao",
                format: this.formatData,
                hidden: false
            }, 
            {
                label:"Containers do BL",
                value: "RetornaQtdCntrBl",
                hidden: false
            },
            {
                label:"Valor CIF",
                value: "ValorReal",
                format: this.formatValorReal,
                hidden: false
            }, 
            {
                label:"Cliente",
                value: "RazaoCliente",
                hidden: false
            }, 
            {
                label:"CNPJ",
                value: "CgcCliente",
                hidden: false
            }, 
            {
                label:"Despachante",
                value: "DscDespachante",
                hidden: !process.env.rig
            }, 
            {
                label:"CNPJ",
                value: "CgcDespachante",
                hidden: !process.env.rig
            }, 
        ]

    }

    formatData(data) {
        if(moment(data).isValid()){
            return moment(data).format('DD/MM/YYYY (HH:mm)');
        } return null;
    }

    formatValorReal(valor) {
        if(!isNaN(parseFloat(valor))) {
            return valor.toLocaleString('pt-BR', {style:'currency', currency:'BRL', minimumFractionDigits: 2});
        } else {
            return "---";
        }
    }
    render() {
        if(!this.controller.blDiInfo) { 
            return null
        } else {
            return (
                <div className="card-expansivel card-expansivel-tabela tabela-acomp-processo">
                    <div style={{overflowX:"hidden"}} className="card p-0 m-0">
                        <Row className={`titulo-booking align-items-center p-0 ${this.controller.dadosProcessoExpandir && 'login-form'}`}>
                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                <h4 className="mt-2 ml-2">Documentos</h4>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                <div className="float-right mt-2 mr-4">
                                    <Button  onClick={ this.controller.toggleDadosProcesso } outline className="collapseItem collapseItem-small" active={false}>
                                    { this.controller.dadosProcessoExpandir ? <IconeSetaSubir /> : <IconeSetaDescer /> }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        {this.controller.dadosProcessoExpandir && 
                        <Row style={{backgroundColor:"white", margin:"0px", padding:"0px"}}>
                            {this.itens.map((item, index) => 
                                <Col className="mb-2 mt-2" xs={12} sm={6} md={4} lg={2} xl={2} key={index}>
                                    {!item.hidden &&
                                        <div>
                                            <Label className="label-disabled">{item.label}</Label>
                                            {
                                                item.format
                                                ?<div style={{fontFamily:'nunito', fontWeight:'bold'}}>{formatNullableValue(item.format(this.controller.blDiInfo[item.value]))}</div>
                                                :<div style={{fontFamily:'nunito', fontWeight:'bold'}}>{formatNullableValue(this.controller.blDiInfo[item.value])}</div>
                                            }
                                        </div>
                                    }
                                </Col>
                            )}
                        </Row>}
                    </div>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/DadosProcesso.js